import React, { useEffect, useState, useMemo } from "react";
import { useWatchState, useModal } from "@/store";
import { BaseService } from "@/service";
import { DealBtn, Comment } from "@/module";
import { findItem, resultProcess } from "@/dic";
import { Modal } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import "./style.less";
import { arr2Dic } from "@/utils";

const NAME = "demandInfo";

const App = () => {
  const [[i18n], [IS_EN]] = useWatchState(["i18n", "IS_EN"]);
  const [[PLATFORM]] = useWatchState(["PLATFORM"]);
  const [[DEMAND_CONTACT = ""]] = useWatchState(["$_DEMAND_CONTACT"]);
  const [[SCOPE_DIRECTION = []]] = useWatchState(["$_SCOPE_DIRECTION"]);
  const SCOPE_DIRECTION_DIC = useMemo(() => {
    return arr2Dic(SCOPE_DIRECTION, "value");
  }, [SCOPE_DIRECTION]);
  const [[{ title = "需求详情", show, hide, width = 1200, resultId = "" }]] =
    useWatchState(["modal." + NAME]);

  const [data, setData] = useState({});
  const scopes = data.scopes || [];

  useEffect(() => {
    if (resultId) {
      BaseService.list({
        table: "thtt_xuqiu",
        columns: "xuqiu_id,name,cover,add_time,process,profile,scope",
        where: {
          xuqiu_id: resultId,
          "thtt_xuqiu.is_delete": 0,
        },
        leftJoin: {
          table: "thtt_organization",
          on: "thtt_xuqiu.unit = thtt_organization.organization_id",
          columns: ["name AS unitName", "profile AS unitProfile"],
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [resultId]);

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
      className="modal-resultInfo"
    >
      <h2>{data.name}</h2>
      <p className="dark-disable">{second2Date(data.add_time)}</p>
      <div className="modal-resultInfo-head p-md border flex child-left-md m-md-t">
        <div className="full child-top-sm">
          <p>
            <span className="bold">{i18n.push.deal.demandModal.org}</span>：
            {data.unitName}
          </p>
        </div>
        <div className="full child-top-sm">
          <p>
            <span className="bold">{i18n.push.deal.demandModal.scope}</span>：
            {data.scope &&
              data.scope
                .split(",")
                .map(
                  (value) =>
                    SCOPE_DIRECTION_DIC[value] &&
                    SCOPE_DIRECTION_DIC[value][IS_EN ? "name_en" : "label"]
                )
                .join("、")}
          </p>
        </div>
      </div>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.demandModal.profile}
        </h2>
        <div
          className="m-sm-t"
          dangerouslySetInnerHTML={{ __html: data.profile }}
        ></div>
      </article>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.demandModal.unitProfile}
        </h2>
        <div
          className="m-sm-t"
          dangerouslySetInnerHTML={{ __html: data.unitProfile }}
        ></div>
      </article>
      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.demandModal.contact}
        </h2>
        <div className="m-sm-t">Ms. Xiao 18131459757</div>
      </article>

      <article className="m-md-t">
        <h2 className="modal-resultInfo-title-second">
          {i18n.push.deal.demandModal.comment}
        </h2>
        <Comment className="m-sm-t" itemId={resultId} type={2} />
      </article>

      {PLATFORM === "THTT" && (
        <DealBtn
          className="modal-info-del bor-ra-xs"
          feebackProps={{ itemId: resultId, itemType: 1 }}
        />
      )}
    </Modal>
  );
};

export default App;
